// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.card-users.modal-verificate{
    width: 100% !important;
    height: 99% !important;
}


.modal-graf-content{
  position: relative;
  display: flex;
  justify-content: center;
  width: 100%;
  height: 100%;
  background-color: white;
}

.cont-graf-disp-graf{
  position: relative;
  display: flex;
  justify-content: center;
  align-items: center;
  width: 92%;
  height: 95%;
  left: 4%;
}
.cont-close-graf-modal{
  position: absolute;
  display: flex;
  justify-content: center;
  align-items: center;
  width: 5%;
  height: 10%;
  top: 0%;
  left: 95%;
  z-index: 1;
}
.img-field-close-graf-modal {
  position: relative;
  height: 50%;
}
.img-field-close-graf-modal:hover{
  height: 55%;
  cursor: pointer;
  transform: scale(1.1)
}















.head-card-addGraph {
  position: relative;
  height: 5%;
  width: 100%;
  background: rgba(195,195,195);
  background: #003757;
  display: flex;
  justify-content: center;
  align-items: center;
}
.content-card-addGraph {
  position: relative;
  height: 80%;
  width: 100%;
  display: block;
  justify-content: center;
  align-items: center;
}
.content-bottom-addGraph{
  position: relative;
  height: 10%;
  width: 100%;
  display: flex;
  justify-content: center;
  align-items: center;
  border-top: 2px solid #003757;
}
.content-menu-search{
  position: relative;
  height: 40px;
  width: 100%;
  display: flex;
  justify-content: center;
  align-items: center;
  border-top: 1px solid var(--txt-color);
  border-bottom: 1px solid var(--txt-color);
  color: var(--txt-color);
}
/* .content-menu-search:nth-child(odd){
  background-color: #f8f9fa;
}
.content-menu-search:nth-child(even){
  background-color: #eeeeee;
} */
.cont-numeric-menu{
  position: relative;
  height: 100% !important;
  width: 10%;
  display: flex;
  justify-content: center;
  align-items: center;
  color:#003757;

  font-weight: bold;
}
.cont-options-menu
{
  position: relative;
  height: 100% !important;
  width: 85%;
  display: flex;
  justify-content: center;
  align-items: center;
}
/*por host*/

.cont-hostid-menu{
  position: relative;
  height: 100% !important;
  width: 10%;
  display: flex;
  justify-content: center;
  align-items: center;
  color:#003757;

  font-weight: bold;
}
.cont-host-menu
{
  position: relative;
  height: 100% !important;
  width: 70%;
  display: flex;
  justify-content: center;
  align-items: center;
}
.cont-ip-menu{
  position: relative;
  height: 100% !important;
  width: 15%;
  display: flex;
  justify-content: center;
  align-items: center;
}
/**/
.cont-action-menu{
  position: relative;
  height: 100%;
  width: 5%;
  display: flex;
  justify-content: center;
  align-items: center;
}
.cont-img-field-delete-graf {
  position: relative;
  width: 100%;
  height: 100%;
  display: flex;
  justify-content: center;
  align-items: center;
}
.img-field-delete-graf {
  position: relative;
  height: 70%;
}
.cont-img-field-delete-graf:hover{
  height: 110%;
  cursor: pointer;
}


.img-field-add-graf {
  position: relative;
  height: 50%;
}
.img-field-add-graf:hover{
  height: 55%;
  cursor: pointer;
  transform: rotate(90deg);
  transition: transform 0.3s ease;
}

/* **************************** horizontal Movil****************************** */
@media (min-width: 500px) and(max-width: 900px) {
 
}
  /* ****************************Movil****************************** */
@media (max-width: 500px) {
  .content-menu-search{
    height: 30%;
  }
}`, "",{"version":3,"sources":["webpack://./src/components/reportes-components/styles/ModalAddMultiGraph.css"],"names":[],"mappings":"AAAA;IACI,sBAAsB;IACtB,sBAAsB;AAC1B;;;AAGA;EACE,kBAAkB;EAClB,aAAa;EACb,uBAAuB;EACvB,WAAW;EACX,YAAY;EACZ,uBAAuB;AACzB;;AAEA;EACE,kBAAkB;EAClB,aAAa;EACb,uBAAuB;EACvB,mBAAmB;EACnB,UAAU;EACV,WAAW;EACX,QAAQ;AACV;AACA;EACE,kBAAkB;EAClB,aAAa;EACb,uBAAuB;EACvB,mBAAmB;EACnB,SAAS;EACT,WAAW;EACX,OAAO;EACP,SAAS;EACT,UAAU;AACZ;AACA;EACE,kBAAkB;EAClB,WAAW;AACb;AACA;EACE,WAAW;EACX,eAAe;EACf;AACF;;;;;;;;;;;;;;;;AAgBA;EACE,kBAAkB;EAClB,UAAU;EACV,WAAW;EACX,6BAA6B;EAC7B,mBAAmB;EACnB,aAAa;EACb,uBAAuB;EACvB,mBAAmB;AACrB;AACA;EACE,kBAAkB;EAClB,WAAW;EACX,WAAW;EACX,cAAc;EACd,uBAAuB;EACvB,mBAAmB;AACrB;AACA;EACE,kBAAkB;EAClB,WAAW;EACX,WAAW;EACX,aAAa;EACb,uBAAuB;EACvB,mBAAmB;EACnB,6BAA6B;AAC/B;AACA;EACE,kBAAkB;EAClB,YAAY;EACZ,WAAW;EACX,aAAa;EACb,uBAAuB;EACvB,mBAAmB;EACnB,sCAAsC;EACtC,yCAAyC;EACzC,uBAAuB;AACzB;AACA;;;;;GAKG;AACH;EACE,kBAAkB;EAClB,uBAAuB;EACvB,UAAU;EACV,aAAa;EACb,uBAAuB;EACvB,mBAAmB;EACnB,aAAa;;EAEb,iBAAiB;AACnB;AACA;;EAEE,kBAAkB;EAClB,uBAAuB;EACvB,UAAU;EACV,aAAa;EACb,uBAAuB;EACvB,mBAAmB;AACrB;AACA,WAAW;;AAEX;EACE,kBAAkB;EAClB,uBAAuB;EACvB,UAAU;EACV,aAAa;EACb,uBAAuB;EACvB,mBAAmB;EACnB,aAAa;;EAEb,iBAAiB;AACnB;AACA;;EAEE,kBAAkB;EAClB,uBAAuB;EACvB,UAAU;EACV,aAAa;EACb,uBAAuB;EACvB,mBAAmB;AACrB;AACA;EACE,kBAAkB;EAClB,uBAAuB;EACvB,UAAU;EACV,aAAa;EACb,uBAAuB;EACvB,mBAAmB;AACrB;AACA,GAAG;AACH;EACE,kBAAkB;EAClB,YAAY;EACZ,SAAS;EACT,aAAa;EACb,uBAAuB;EACvB,mBAAmB;AACrB;AACA;EACE,kBAAkB;EAClB,WAAW;EACX,YAAY;EACZ,aAAa;EACb,uBAAuB;EACvB,mBAAmB;AACrB;AACA;EACE,kBAAkB;EAClB,WAAW;AACb;AACA;EACE,YAAY;EACZ,eAAe;AACjB;;;AAGA;EACE,kBAAkB;EAClB,WAAW;AACb;AACA;EACE,WAAW;EACX,eAAe;EACf,wBAAwB;EACxB,+BAA+B;AACjC;;AAEA,gFAAgF;AAChF;;AAEA;EACE,oEAAoE;AACtE;EACE;IACE,WAAW;EACb;AACF","sourcesContent":[".card-users.modal-verificate{\r\n    width: 100% !important;\r\n    height: 99% !important;\r\n}\r\n\r\n\r\n.modal-graf-content{\r\n  position: relative;\r\n  display: flex;\r\n  justify-content: center;\r\n  width: 100%;\r\n  height: 100%;\r\n  background-color: white;\r\n}\r\n\r\n.cont-graf-disp-graf{\r\n  position: relative;\r\n  display: flex;\r\n  justify-content: center;\r\n  align-items: center;\r\n  width: 92%;\r\n  height: 95%;\r\n  left: 4%;\r\n}\r\n.cont-close-graf-modal{\r\n  position: absolute;\r\n  display: flex;\r\n  justify-content: center;\r\n  align-items: center;\r\n  width: 5%;\r\n  height: 10%;\r\n  top: 0%;\r\n  left: 95%;\r\n  z-index: 1;\r\n}\r\n.img-field-close-graf-modal {\r\n  position: relative;\r\n  height: 50%;\r\n}\r\n.img-field-close-graf-modal:hover{\r\n  height: 55%;\r\n  cursor: pointer;\r\n  transform: scale(1.1)\r\n}\r\n\r\n\r\n\r\n\r\n\r\n\r\n\r\n\r\n\r\n\r\n\r\n\r\n\r\n\r\n\r\n.head-card-addGraph {\r\n  position: relative;\r\n  height: 5%;\r\n  width: 100%;\r\n  background: rgba(195,195,195);\r\n  background: #003757;\r\n  display: flex;\r\n  justify-content: center;\r\n  align-items: center;\r\n}\r\n.content-card-addGraph {\r\n  position: relative;\r\n  height: 80%;\r\n  width: 100%;\r\n  display: block;\r\n  justify-content: center;\r\n  align-items: center;\r\n}\r\n.content-bottom-addGraph{\r\n  position: relative;\r\n  height: 10%;\r\n  width: 100%;\r\n  display: flex;\r\n  justify-content: center;\r\n  align-items: center;\r\n  border-top: 2px solid #003757;\r\n}\r\n.content-menu-search{\r\n  position: relative;\r\n  height: 40px;\r\n  width: 100%;\r\n  display: flex;\r\n  justify-content: center;\r\n  align-items: center;\r\n  border-top: 1px solid var(--txt-color);\r\n  border-bottom: 1px solid var(--txt-color);\r\n  color: var(--txt-color);\r\n}\r\n/* .content-menu-search:nth-child(odd){\r\n  background-color: #f8f9fa;\r\n}\r\n.content-menu-search:nth-child(even){\r\n  background-color: #eeeeee;\r\n} */\r\n.cont-numeric-menu{\r\n  position: relative;\r\n  height: 100% !important;\r\n  width: 10%;\r\n  display: flex;\r\n  justify-content: center;\r\n  align-items: center;\r\n  color:#003757;\r\n\r\n  font-weight: bold;\r\n}\r\n.cont-options-menu\r\n{\r\n  position: relative;\r\n  height: 100% !important;\r\n  width: 85%;\r\n  display: flex;\r\n  justify-content: center;\r\n  align-items: center;\r\n}\r\n/*por host*/\r\n\r\n.cont-hostid-menu{\r\n  position: relative;\r\n  height: 100% !important;\r\n  width: 10%;\r\n  display: flex;\r\n  justify-content: center;\r\n  align-items: center;\r\n  color:#003757;\r\n\r\n  font-weight: bold;\r\n}\r\n.cont-host-menu\r\n{\r\n  position: relative;\r\n  height: 100% !important;\r\n  width: 70%;\r\n  display: flex;\r\n  justify-content: center;\r\n  align-items: center;\r\n}\r\n.cont-ip-menu{\r\n  position: relative;\r\n  height: 100% !important;\r\n  width: 15%;\r\n  display: flex;\r\n  justify-content: center;\r\n  align-items: center;\r\n}\r\n/**/\r\n.cont-action-menu{\r\n  position: relative;\r\n  height: 100%;\r\n  width: 5%;\r\n  display: flex;\r\n  justify-content: center;\r\n  align-items: center;\r\n}\r\n.cont-img-field-delete-graf {\r\n  position: relative;\r\n  width: 100%;\r\n  height: 100%;\r\n  display: flex;\r\n  justify-content: center;\r\n  align-items: center;\r\n}\r\n.img-field-delete-graf {\r\n  position: relative;\r\n  height: 70%;\r\n}\r\n.cont-img-field-delete-graf:hover{\r\n  height: 110%;\r\n  cursor: pointer;\r\n}\r\n\r\n\r\n.img-field-add-graf {\r\n  position: relative;\r\n  height: 50%;\r\n}\r\n.img-field-add-graf:hover{\r\n  height: 55%;\r\n  cursor: pointer;\r\n  transform: rotate(90deg);\r\n  transition: transform 0.3s ease;\r\n}\r\n\r\n/* **************************** horizontal Movil****************************** */\r\n@media (min-width: 500px) and(max-width: 900px) {\r\n \r\n}\r\n  /* ****************************Movil****************************** */\r\n@media (max-width: 500px) {\r\n  .content-menu-search{\r\n    height: 30%;\r\n  }\r\n}"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
